module.exports = __webpack_public_path__ + "img/ltku-3x.abb51f5.jpg";